import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1509Component } from './kymw1509.component';
import { GetCwsIconPublishOrderList } from './api-services/get-cws-icon-publish-order-list-service';
import { UpdateCwsIconPublishOrder } from './api-services/update-cws-icon-publish-order-service';

/**
 * アイコン掲載順設定画面 モジュール設定クラス
 *
 * @export KYMW1509Module
 * @class KYMW1509Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
  ],
  declarations: [
    KYMW1509Component,
  ],
  providers: [
    GetCwsIconPublishOrderList,
    UpdateCwsIconPublishOrder
  ],
})
export class KYMW1509Module {
}
